import FE from './images/screenshots/FUNCTION_EARTH_SCREENSHOTS.jpg'
import BTM from './images/screenshots/BEACHTIDES_MOBILE_SCREENSHOTS.jpg';
import TP from './images/screenshots/TP-SCREENSHOTS.jpg';
import BT from './images/screenshots/BEACHTIDES-SCREENSHOTS.jpg';
import CSC from './images/screenshots/CS-CARDS-SCREENSHOTS.jpg';
import SG from './images/screenshots/SG-SCREENSHOTS.jpg';
import PT from './images/screenshots/PRIMETHREE-SCREENSHOTS.jpg';

export  const projectsArray = [
  {
    name: 'functionEarth',
    h2: 'Function Earth',
    description: 'React Native application that tracked what we are doing around the world to reduce our footprint and preserve our environment for future generations. Built a compost bin? Recycled? Picked up trash from the ocean? Helped the elderly? Took care of an animal? Use Function Earth to log these actions. Race other cities, states and countries to be the greenest region in the world!',
    image: FE,
    archived: true,
    githubLinkClient: 'https://github.com/JacobMacInnis/function-earth',
    githubLinkServer: 'https://github.com/JacobMacInnis/server-function-earth',    
    techList: ['JavaScript', 'Node', 'React-Native', 'React', 'Redux', 'Express', 'MongoDB', 'Mongoose', 'mLab', 'HTML5', 'CSS3', 'Passport-JWT', 'Jest', 'Mocha', 'Chai', 'Enzyme', 'Travis-CI', 'Heroku'],
    tags: ['mobile', 'legacy']
  },
  {
    name: 'beachTidesMobile',
    h2: 'Beach Tides Mobile App',
    description: 'MVP React-Native application built to give real time and future tide predictions for the coastal United States. Use BeachTides to search by zip code or city and get beach tide predictions. Search for tide information without creating accounts',
    image: BTM,
    archived: true,
    githubLinkClient: 'https://github.com/JacobMacInnis/BeachTides',
    githubLinkServer: 'https://github.com/JacobMacInnis/beach-tides-server',    
    techList: ['TypeScript', 'JavaScript', 'Node', 'React', 'Redux', 'Express', 'Socket.io', 'MongoDB', 'Mongoose', 'mLab', 'HTML5', 'CSS3', 'Passport-JWT', 'Mocha', 'Chai', 'Enzyme', 'Travis-CI', 'Heroku'],
    tags: ['mobile', 'legacy']
  },
  {
    name: 'thinkPrograming',
    h2: 'Think Programming',
    description: 'A place to challenge other coding enthusiasts in languages or programming categories. Be the fastest and cleanest coder to level up quickly, gaining experience and coding muscle memory.',
    image: TP,
    archived: true,
    githubLinkClient: 'https://github.com/thinkful-ei23/think-programming-client',
    githubLinkServer: 'https://github.com/thinkful-ei23/think-programming-server',    
    techList: ['Node', 'React', 'Redux', 'JavaScript', 'Express', 'Socket.io', 'MongoDB', 'Mongoose', 'mLab', 'HTML5', 'CSS3', 'Google-OAuth-2.0', 'Passport-JWT', 'Mocha', 'Chai', 'Enzyme', 'Travis-CI', 'Heroku'],
    tags: ['legacy', 'web']
  },
  {
  name: 'beachtides',
  h2: 'Beach Tides Web App',
  description: 'A full-stack, mobile-first responsive web app that gives users tidal predictions for the coastal U.S. Search by zip code or city and state. Create an account with Google OAuth 2.0 to save locations and more.',
  image: BT,
    archived: true,
  githubLinkClient: 'https://github.com/JacobMacInnis/beach-tides-client',
  githubLinkServer: 'https://github.com/JacobMacInnis/beach-tides-server',
  techList: ['Node', 'React', 'Redux', 'JavaScript', 'Express', 'MongoDB', 'Mongoose', 'mLab', 'HTML5', 'CSS3', 'Google-OAuth-2.0', 'Passport-JWT', 'Mocha', 'Chai', 'Enzyme', 'Travis-CI', 'Heroku'],
  tags: ['legacy', 'cloud']
}, {
  name: 'CS Cards',
  h2: 'CS Cards',
  description: 'Using a spaced repetition algorithm, CS Cards teaches users computer science concepts. It is built with linked lists in MongoDB and adjusts the data structures based on user answers.',
  image: CSC,
    archived: true,
  githubLinkClient: 'https://github.com/thinkful-ei23/Client-CS-Cards',
  githubLinkServer: 'https://github.com/thinkful-ei23/Server-CS-Cards',
  techList: ['Node', 'React', 'Redux', 'Socket.io', 'WebSockets','JavaScript', 'Express', 'MongoDB', 'Mongoose', 'mLab', 'HTML5', 'CSS3', 'JWT-Auth', 'Passport-JWT', 'Mocha', 'Chai', 'Enzyme', 'Heroku' ],
  tags: ['legacy', 'web']
}, {
  name: 'scottish-gaelic',
  h2: 'Scottish Gaelic',
  description: 'Scottish Gaelic is a language learning app designed to improve your ability to learn the beautiful Scottish language of Gaelic. Using a spaced repetition algorithm, it teaches words and phrases.',
  image: SG,
    archived: true,
  githubLinkClient: 'https://github.com/JacobMacInnis/scottish-gaelic-client',
  githubLinkServer: 'https://github.com/JacobMacInnis/scottish-gaelic-server',
  techList: ['Node', 'React', 'Redux', 'Socket.io', 'WebSockets','JavaScript', 'Express', 'MongoDB', 'Mongoose', 'mLab', 'HTML5', 'CSS3', 'JWT-Auth', 'Passport-JWT', 'Mocha', 'Chai', 'Enzyme', 'Heroku' ],
  tags: ['legacy', 'web']
},
{
  name: 'PrimeThree',
  h2: 'Prime Three',
  description: 'One-day project built to find the first prime number that contains the three digits a user inputs.',
  image: PT,
    archived: true,
  githubLinkClient: 'https://github.com/JacobMacInnis/primethree-client',
  githubLinkServer: 'https://github.com/JacobMacInnis/primethree-server',
  techList: ['Node', 'React', 'Redux','JavaScript', 'Express', 'MongoDB', 'Mongoose', 'mLab', 'HTML5', 'CSS3', 'Mocha', 'Chai', 'Enzyme', 'Sinon', 'Heroku' ],
  tags: ['legacy', 'web']
}
];
// {
//   name: 'bookmarkcentral',
//   h2: 'Bookmark Central',
//   description: 'Bookmark Central is an early front-end responsive web app.  It allows users to save urls and rate them using 0 to 5 star rating.  Users can change ratings, edit descriptions and delete bookmarks.',
//   projectLink: 'https://thinkful-ei23.github.io/jacob-bookmarks-app/',
//   linkText: 'BookmarkCentral',
//   githubLinkClient: 'https://github.com/thinkful-ei23/jacob-bookmarks-app',
//   techList: ['JavaScript', 'JQuery', 'HTML5', 'CSS3', 'Github-Pages' ]
// }
